import veteraIcon from '@/assets/integrations/vetera.png';
import vetpraxisIcon from '@/assets/integrations/vetpraxis.png';
import inbehandlungIcon from '@/assets/integrations/inbehandlung.svg';
import lupaIcon from '@/assets/integrations/lupa.png';
import petsxlIcon from '@/assets/integrations/petsxl.svg';
import vetdreamIcon from '@/assets/integrations/vetdream.svg';

export interface IntegrationBrand {
  name: string;
  icon: string;
}

/** PMS brands keyed by manta's `IntegrationSubType`, as in the Manta dashboard. */
const BRANDS: Record<string, IntegrationBrand> = {
  vetera: { name: 'Vetera', icon: veteraIcon },
  vet_praxis: { name: 'Vetpraxis', icon: vetpraxisIcon },
  inbehandlung: { name: 'InBehandlung', icon: inbehandlungIcon },
  inbehandlung_v2: { name: 'InBehandlung', icon: inbehandlungIcon },
  lupa: { name: 'Lupa', icon: lupaIcon },
  petsxl: { name: 'PetsXL', icon: petsxlIcon },
  vetdream: { name: 'VetDream', icon: vetdreamIcon },
};

export function integrationBrand(
  subType: string | null | undefined,
): IntegrationBrand | undefined {
  return subType ? BRANDS[subType] : undefined;
}
